import React from "react";
import BaseModal from "../modals/BaseModal";

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 * @param {() => void} props.onAddFromMarketplace
 * @param {() => void} props.onInviteInfluencer
 */
function AddInfluencerSourceModal({
  open,
  onClose,
  onAddFromMarketplace,
  onInviteInfluencer,
}) {
  return (
    <BaseModal
      open={open}
      title="Add influencer"
      onClose={onClose}
      className="max-w-[520px]"
    >
      <div className="p-4 sm:p-5 space-y-3">
        <div className="space-y-1">
          <p className="text-xs md:text-sm text-[#2A2622] font-semibold leading-snug">
            Choose how you want to add an influencer.
          </p>
          <p className="text-xs md:text-sm text-[#6B6661] leading-snug">
            Pick from the marketplace or send a direct invite.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button
            type="button"
            onClick={onAddFromMarketplace}
            className="w-full rounded-xl bg-orange-500 px-2 py-2 min-h-[44px] text-center text-xs md:text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/40 focus-visible:ring-offset-2 transition-colors"
          >
            Add from marketplace
          </button>
          <button
            type="button"
            onClick={onInviteInfluencer}
            className="w-full rounded-xl bg-orange-500 px-2 py-2 min-h-[44px] text-center text-xs md:text-sm font-semibold text-white shadow-sm hover:bg-orange-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/40 focus-visible:ring-offset-2 transition-colors"
          >
            Invite influencer
          </button>
        </div>

        <div className="rounded-xl border border-orange-100 bg-orange-50/60 p-3">
          <p className="text-xs md:text-sm font-semibold text-[#2A2622] leading-snug">
            Note: <span className="text-orange-500 text-xs md:text-sm text-[#6B6661]"> To invite an influencer, please select a campaign first.</span>
          </p>
        </div>
      </div>
    </BaseModal>
  );
}

export default AddInfluencerSourceModal;
